function Profile() {
  return (
    <section id="home" className="intro-profile md-mb50">
      <div className="row rest">
        <div className="col-lg-4 box-img main-bg">
          <div className="cont valign">
            <div className="full-width">
              <div className="img">
                <img
                  src="/assets/imgs/header/profile5.png"
                  alt=""
                  style={{ borderRadius: "5px" }}
                />
                <span className="icon">
                  <img src="/assets/imgs/header/icon1.png" alt="" />
                </span>
                <span className="icon">
                  <img src="/assets/imgs/header/icon2.png" alt="" />
                </span>
                <span className="icon">
                  <img src="/assets/imgs/header/icon4.png" alt="" />
                </span>
              </div>
              <div className="info text-center mt-30">
                <h5>Nikhil Hingwe</h5>
                <p className="fz-13 text-u">Full Stack Developer</p>
              </div>
              <div className="social text-center mt-20">
                <a
                  href="mailto:hingwe90@gmail.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fas fa-envelope"></i>
                </a>
                <a href="tel:+917276389688">
                  <i className="fas fa-phone"></i>
                </a>
                <a
                  href="https://github.com/nikhilhingwe"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-github"></i>
                </a>
                <a
                  href="https://www.linkedin.com/in/nikhil-h-780b681b8/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-linkedin-in"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-8 content main-bg">
          <h1>
            Hello, I’m <span className="main-color">Nikhil</span>,{" "}
            <span className="bord"> Full-Stack Developer </span> and WordPress
            Expert <i></i>
            focused on innovation.
          </h1>
          <div className="stauts mt-80">
            <div className="d-flex align-items-center">
              <div className="mr-40">
                <div className="d-flex align-items-center">
                  <h2>3</h2>
                  <p>
                    Years <br /> of Experience
                  </p>
                </div>
              </div>
              {/* <div className="mr-40">
                <div className="d-flex align-items-center">
                  <h2>6k</h2>
                  <p>
                    Clients <br /> Worldwide
                  </p>
                </div>
              </div> */}
              <div>
                <div className="butn-presv">
                  <a
                    href="https://drive.google.com/uc?export=download&id=1UF_Ao4iI9qpX_UibmKQIRhOstv5h-TOH"
                    className="butn butn-md butn-bord radius-5 skew"
                    download
                  >
                    <span>Download C.V</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Profile;
